import {
    PhoneInput as ReactPhoneInput,
    defaultCountries,
    ParsedCountry,
} from 'react-international-phone';
import { cn } from '@/lib/utils';
import 'react-international-phone/style.css';
import './PhoneInput.css';

interface PhoneInputProps {
    value: string;
    onChange: (value: string, country?: ParsedCountry) => void;
    placeholder?: string;
    className?: string;
    error?: string;
    disabled?: boolean;
}

export function PhoneInput({
    value,
    onChange,
    placeholder = 'Enter phone number',
    className,
    error,
    disabled = false,
}: PhoneInputProps) {
    return (
        <div className={cn('flex flex-col gap-2', className)}>
            <div
                className={cn(
                    'phone-input-wrapper',
                    error && 'phone-input-wrapper-error',
                    disabled && 'phone-input-wrapper-disabled',
                )}
            >
                <ReactPhoneInput
                    value={value}
                    onChange={(phone, { country }) => {
                        onChange(phone, country);
                    }}
                    countries={defaultCountries}
                    disabled={disabled}
                    disableDialCodeAndPrefix
                    showDisabledDialCodeAndPrefix
                    inputClassName="phone-input-field"
                    countrySelectorStyleProps={{
                        buttonClassName: 'phone-input-country-button',
                        dropdownStyleProps: {
                            className: 'phone-input-dropdown',
                        },
                    }}
                    dialCodePreviewStyleProps={{
                        className: 'phone-input-dial-code',
                    }}
                    placeholder={placeholder}
                />
            </div>
            {error && <p className="text-xs text-error-500">{error}</p>}
        </div>
    );
}
